/*jshint esversion: 6 */

function URL() {
  if (process.env.NODE_ENV == "development")
    return window.location.protocol + "//" + window.location.hostname + ":8008";

  return (
    window.location.protocol +
    "//" +
    window.location.hostname +
    ":" +
    window.location.port
  );
}

function wsURL() {
  var protocol;

  if (window.location.protocol == "https:") protocol = "wss:";
  else protocol = "ws:";

  if (process.env.NODE_ENV == "development")
    return protocol + "//" + window.location.hostname + ":8008";

  return (
    protocol + "//" + window.location.hostname + ":" + window.location.port
  );
}

function header() {
  return {
    headers: {
      Empresa: getEmp(),
    },
  };
}

function getEmp() {
    let urlParams = new URLSearchParams(window.location.search);
    let empresa = urlParams.get('e');
    
    if (!empresa) empresa = 1;

    return empresa;
}

export default {
  URL,
  wsURL,
  header,
  getEmp,
};
